/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse
 */
export interface FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse
     */
    Token: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse(value: object): value is FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse {
    if (!('Token' in value) || value['Token'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse {
    return FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Token': json['Token'],
    };
}

export function FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseToJSON(json: any): FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse {
    return FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Token': value['Token'],
    };
}

